import WordTooltip from './WordTooltip'
import MenuTooltip from './MenuTooltip'
import Tooltip from './Tooltip'

export { WordTooltip, MenuTooltip }
export default Tooltip
